module.exports = __webpack_public_path__ + "static/media/doneCircle.738519d3.svg";